<template>
    <div
        class="w-full rounded-lg flex flex-col justify-center items-center p-8 mt-6"
    >
        <HeaderIcon>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#5F6D7E" style="opacity:1;"><path  d="M22 13.341A6 6 0 0 0 14.341 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zm-9.94-1.658L5.648 6.238L4.353 7.762l7.72 6.555l7.581-6.56l-1.308-1.513zM19 22l-3.536-3.535l1.415-1.415L19 19.172l3.535-3.536l1.415 1.414z"/></svg>
        </HeaderIcon>

        <div class="w-full max-w-lg flex flex-col justify-center items-center mt-8 z-50">
            <Intro :heading-text="headingText" :sub-text="subText" />

            <div class="mt-2">
                <span class="text-sm text-primary-gray cursor-pointer underline font-semibold" @click="() => handlePrevious()">Change Number</span>
            </div>

            <div class="w-full max-w-sm mt-6">
                <div class="mb-4 flex flex-col justify-center items-center gap-2">
                    <GenericInputOTP
                        id="otp"
                        v-model="formData.payload.otp"
                        name="otp"
                        maxlength="4"
                    />
                    <p v-for="error in getValidationErrors('otp')" :key="error" class="text-red-500 text-sm">
                        {{ error }}
                    </p>
                </div>


                <div class="my-6">
                    <button
                        :disabled="isLoading"
                        @click="validateOtp"
                        class="w-full py-2 px-4 text-sm bg-primary-green text-white font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-primary-green"
                    >
                        <span v-if="isLoading">Processing...</span>
                        <span v-else>Verify OTP</span>
                    </button>
                </div>
                <div class="text-center mt-2">
                    <p class="text-sm text-primary-gray">
                        Experiencing issues recieving the code?
                    </p>
                    <button
                        :disabled="isResending || cooldown > 0"
                        @click="handleResend"
                        class="text-sm primary-font-color font-medium hover:underline disabled:text-gray-400"
                    >
                        <span v-if="cooldown > 0">
                            Resend code in {{ cooldown }}s
                        </span>
                        <span v-else-if="isResending">Resending...</span>
                        <span v-else class="underline">Resend code</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, computed } from "vue";
import { useResendOtp } from "@/composables";
import { useSignupWizardStore } from "@/store/signup-wizard";
import { storeToRefs } from "pinia";
import HeaderIcon from "./components/HeaderIcon.vue";
import GenericInputOTP from "@/components/ui/input-otp/GenericInputOTP.vue";
import Intro from "./components/Intro.vue";
const signupWizardStore = useSignupWizardStore();

const {isLoading, formData, isKeLocale} = storeToRefs(signupWizardStore);
const {handlePrevious, fetchSignupState, validateOtp, getValidationErrors} = signupWizardStore;

const {isResending, cooldown, resendOtp } = useResendOtp();

const headingText = "Enter Verification Code";
const maskPhone = (phone) => {
    const minLength = isKeLocale.value ? 10 : 14;
    if (!phone || phone.length < minLength) return phone;
    return `${phone.slice(0, 5)}***${phone.slice(-3)}`;
};
const subText = computed(() => `We have just sent a verification code to ${maskPhone(formData.value.phoneWithDialCode || formData.value?.payload?.phone)}`);

const handleResend = async () => {
    await resendOtp({
        phone: formData.value.phone,
    });
};

onMounted(async () => {
    await fetchSignupState();
})
</script>
